import {
  IMagicUserLogin,
  IUserCreate,
  IUserForgotPassword,
  IUserLogin,
  IUserOnboarding,
  IUserRespone
} from '@app-types/api/user.types';
import {IWSUserInviteParent, IAppToken, IDeviceData} from '@app-types/websocket/user.types';
import { CountryType } from '@components/calendar2/holidays/holidayTypes';
import {createAction} from 'redux-act';

export const reloadResources = createAction('Reload resources for account'); 
export interface IEmailAddressActivation {
  accountId: number;
  familyId: number;
  requestId: string;
}
// familyId is the family the toggle was shown for, so the change is never sent to another one.
export interface IAutoApproveSuggestions {
  familyId: number;
  enabled: boolean;
}
// familyId is the family the toggle was shown for, so the change is never sent to another one.
export interface IDisablePreviews {
  familyId: number;
  disabled: boolean;
}
export const activateEmailAddress = createAction<IEmailAddressActivation>('Activate forwarding email address');
export const emailAddressActivationFinished = createAction<{requestId: string; failed: boolean}>('Email activation finished');
// Leaves a group nobody else was invited to (the account's own role there becomes DELETED) and switches to another group.
export interface IDeleteGroup {
  accountId: number;
  familyId: number;
  requestId: string;
}
export const deleteGroup = createAction<IDeleteGroup>('Delete group');

export const appSettings = createAction<any>('calendar app settings');

export const selectLanguage = createAction<string>('Select Language');
export const storeLanguage = createAction<{language:string, timeZone:string}>('Select Language and timezone');
export const storeDeviceData = createAction<IDeviceData>('Store Device Data');

export const login = createAction<IUserLogin>('Login user');
export const loginMagic = createAction<IMagicUserLogin>('Login user with magic token');
export const loginSuccess = createAction<IUserRespone>('Login user success');

export const reportProblem = createAction<string>('Report a problem');

export const createUser = createAction<IUserCreate>('Create user');
export const createUserSuccess = createAction<IUserRespone>('Create user success');

export const uploadOfflineEventAnalysis = createAction<{imageData:Blob, auth:string, familyId:number, action:string}>('Upload image');


export const getUser = createAction('Get user');

export const selectFamily = createAction<number>('Select Family');
export const onboardingSetActiveStep = createAction<number>('Onboarding set active step');
export const dismissErrorMessage = createAction('Dismiss error message');
export const dismissSuccessMessage = createAction('Dismiss success message');
export const displayErrorMessage = createAction<string>('Display error message');
export const displaySuccessMessage = createAction<string>('Display success message');
export const updateAppToken = createAction<IAppToken>('Update AppToken');
export const storeAppToken = createAction<string>('Store AppToken');
export const onboarding = createAction<IUserOnboarding>('Onboarding');

export const bootstrapTime = createAction<number>('bootstrap time');

export const forgotPassword = createAction<IUserForgotPassword>('Forgot password');

export const eraseAccount = createAction('Erase Account');
export const logout = createAction('Logout');
export const changePassword = createAction<string>('Change password');
export const updateEmail = createAction<string>('Change email');
export const inviteParent = createAction<IWSUserInviteParent>('Invite parent');

export const seenHelp = createAction<string>('dismissed help');

export const getCampaignToken = createAction<string>('Get campaigns');
export const getCampaignTokenSuccess = createAction<any>('Got inviters');

export const claimSpecialOffer = createAction<{familyId:number, accountId:number, offer:string}>('Accept offer');

export const signupInvite = createAction<IUserCreate>('Signup invite');
export const getInvitedUser = createAction<any>('Get invited user');
export const storeCampaignToken = createAction<any>('Store Compaign Token');
export const storeInviteToken = createAction<string>('Store Invite Token');
export const getInviteToken = createAction<any>('Get Invite Token');
export const getInviteTokenSuccess = createAction<string>('Get invite token success');

export const getMunicipality = createAction<{latitude:string, longitude:string}>('Get municipality');
export const getMunicipalitySuccess = createAction<string>('Get municipality success');

export const reportWebsocketErrorToUser = createAction<any>('Report Error To User');
export const checkServerStatus = createAction<string>('Check server maintenance status');

export const dismissShareModal = createAction<any>('Dismiss share modal');
export const updateCalendarSettings = createAction<any>('Update Calendar Settings');
export const updateCalendarSettingsSynch = createAction<boolean>('Update synch local calendar');
export const updateCalendarSettingsExclude = createAction<string[]>('Update synch local calendar');
export const updateFamilyColors = createAction<string[]>('UpdateFamilyColors');

export const saveHolidayRegion = createAction<CountryType>('Store country for holidays import');

export const awaitReplyOnRequest = createAction<string>('Await Reply on request');
export const dismissHelpNotice = createAction<string>('Dismiss help notice');
export const unDismissHelpNotice = createAction<string>('UN-Dismiss help notice');
export const setShowWeekNum = createAction<boolean>('Show week num');
// Parent id whose weeks to show, 0 for everyone's. Saved on the server with the calendar settings.
export const setOnlyWeeksOf = createAction<number>('Show only weeks of parent');
export const setShowActivitiesInEditMode = createAction<boolean>('Show activities in edit mode');

// 0 normal, 1 strict, 2 very strict message screening. Saved on the account.
export const updateToxicCheckLevel = createAction<number>('Update toxic check level setting');
export const enhancedTextSize = createAction<boolean>('Update enhanced text size setting');
export const setEnhancedVisibility = createAction<boolean>('Update enhanced visibility setting');
export const setAutoApproveSuggestions = createAction<IAutoApproveSuggestions>('Update auto-approve suggestions setting');
// The member's own setting for the family; the server echoes it to everyone in a familyUpdate.
export const setDisablePreviews = createAction<IDisablePreviews>('Update disable previews setting');
// true always dark, false always light, undefined follows the phone or browser.
export const setDarkMode = createAction<boolean | undefined>('Update dark mode setting');



// WEBPACK FOOTER //
// ./src/services/user/user.actions.ts